'use client'

import { useEffect, useRef } from 'react'

import { type GA4Item, pushViewItemListOnce } from '@/_utils/analytics/datalayer'

interface AGA4ViewItemListEventProps {
	itemListId: string
	itemListName: string
	items: GA4Item[]
}

/**
 * Fires GA4 `view_item_list` once per mount when items are available.
 * Render this inside any server component that has the list items available at SSR time.
 */
export function AGA4ViewItemListEvent({
	itemListId,
	itemListName,
	items
}: AGA4ViewItemListEventProps) {
	const firedRef = useRef(false)

	useEffect(() => {
		if (firedRef.current || items.length === 0) return

		const pushed = pushViewItemListOnce(itemListId, {
			item_list_id: itemListId,
			item_list_name: itemListName,
			items
		})
		if (pushed) firedRef.current = true
	}, [itemListId, itemListName, items])

	return null
}
